export const zIndexGuidedTour: Record<string, number> = {
  base: 1300,
  layover: 1301,
  popper: 1302,
  arrow: 1303,
}
